"use strict";

exports.__esModule = true;
var _TicketScreenToolbar = require("./TicketScreenToolbar");
Object.keys(_TicketScreenToolbar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TicketScreenToolbar[key]) return;
  exports[key] = _TicketScreenToolbar[key];
});